import React from 'react';

const CardModule = ({ data, config }) => {
  const cardLayout = config.layout || 'grid';
  const cardSize = config.size || 'medium';

  const sizeClasses = {
    small: 'p-3',
    medium: 'p-4',
    large: 'p-6'
  };

  const layoutClasses = {
    grid: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4',
    list: 'space-y-4',
    carousel: 'flex space-x-4 overflow-x-auto'
  };

  return (
    <div className={layoutClasses[cardLayout]}>
      {data.map((item, index) => (
        <div key={index} className={`theme-bg border theme-border-secondary rounded-lg ${sizeClasses[cardSize]} hover:shadow-md transition-shadow`}>
          <h4 className="font-semibold theme-primary mb-2">
            {typeof item.title === 'object' ? JSON.stringify(item.title) : 
             typeof item.title === 'string' || typeof item.title === 'number' ? item.title : 
             typeof item.name === 'object' ? JSON.stringify(item.name) : 
             typeof item.name === 'string' || typeof item.name === 'number' ? item.name : 'Untitled'}
          </h4>
          <p className="theme-secondary text-sm mb-2">
            {typeof item.description === 'object' ? JSON.stringify(item.description) : 
             typeof item.description === 'string' || typeof item.description === 'number' ? item.description : 
             typeof item.subtitle === 'object' ? JSON.stringify(item.subtitle) : 
             typeof item.subtitle === 'string' || typeof item.subtitle === 'number' ? item.subtitle : ''}
          </p>
          <div className="flex items-center justify-between">
            <span className="text-2xl font-bold text-primary-600">
              {typeof item.value === 'object' ? JSON.stringify(item.value) : 
               typeof item.value === 'string' || typeof item.value === 'number' ? item.value : 
               typeof item.count === 'object' ? JSON.stringify(item.count) : 
               typeof item.count === 'string' || typeof item.count === 'number' ? item.count : '0'}
            </span>
            {item.trend && (
              <span className={`text-sm ${item.trend === 'up' ? 'text-green-600' : 'theme-primary'}`}>
                {item.trend === 'up' ? '↑' : '↓'} {typeof item.trendValue === 'object' ? JSON.stringify(item.trendValue) : item.trendValue || '0%'}
              </span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default CardModule;
